// relatorios-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    ", cancele o boleto duplicado ou ajuste o": ", cancele el boleto duplicado o ajuste el",
    "A competência é o mês do vencimento do boleto no Gestão Click. Para corrigir, abra o boleto no ERP pelo botão": "El mes de facturación es el mes del vencimiento del boleto en Gestão Click. Para corregir, abra el boleto en el ERP con el botón",
    "Abastecimentos (Concentrador)": "Cargas de Combustible (Concentrador)",
    "Abastecimentos (Todos)": "Cargas de Combustible (Todos)",
    "Abastecimentos em Andamento": "Cargas de Combustible en Curso",
    "Abrir": "Abrir",
    "Agrupado por": "Agrupado por",
    "Analisando sua solicitação": "Analizando su solicitud",
    "Aprovado por": "Aprobado por",
    "Bico:": "Pico:",
    "CNPJ:": "CNPJ:",
    "CPF do Cliente": "CPF del Cliente",
    "Cliente CPF": "Cliente CPF",
    "Cliente não identificado": "Cliente no identificado",
    "Clientes Bloqueados": "Clientes Bloqueados",
    "Clientes sem número da sorte": "Clientes sin número de la suerte",
    "Cobranças atualizadas com sucesso!": "¡Cobros actualizados con éxito!",
    "Combustivel": "Combustible",
    "Como corrigir": "Cómo corregir",
    "Como posso ajudar?": "¿Cómo puedo ayudar?",
    "Competência Final": "Mes de Facturación Final",
    "Competência Inicial": "Mes de Facturación Inicial",
    "Consulta:": "Consulta:",
    "Cupom/Série": "Cupón/Serie",
    "Dados do Abastecimento": "Datos de la Carga de Combustible",
    "Data Concentrador": "Fecha Concentrador",
    "Data Operacional": "Fecha Operativa",
    "Data atual": "Fecha actual",
    "Data da Aprovação": "Fecha de la Aprobación",
    "Data da Venda": "Fecha de la Venta",
    "Data de envio": "Fecha de envío",
    "Data do concentrador": "Fecha del concentrador",
    "Desconto concedido": "Descuento otorgado",
    "Desconto: R$": "Descuento: R$",
    "Detalhe": "Detalle",
    "Detalhe por Frentista": "Detalle por Playero",
    "Dias Trabalhados": "Días Trabajados",
    "Diferença": "Diferencia",
    "Diferença: R$": "Diferencia: R$",
    "Diferenças por Posto (": "Diferencias por Estación (",
    "Digite o CPF": "Ingrese el CPF",
    "Dispositivos por marca": "Dispositivos por marca",
    "Editar cobrança": "Editar cobro",
    "Emissão no ERP": "Emisión en el ERP",
    "Encerrante Fim": "Totalizador Fin",
    "Encerrante Início": "Totalizador Inicio",
    "Erro": "Error",
    "Erro ao atualizar cobranças": "Error al actualizar cobros",
    "Erro ao carregar clientes com mais pontos gerados": "Error al cargar clientes con más puntos generados",
    "Erro ao processar solicitação": "Error al procesar la solicitud",
    "Erro ao resolver Erro": "Error al resolver Error",
    "Erro resolvido com sucesso": "Error resuelto con éxito",
    "Erros de Conciliação (": "Errores de Conciliación (",
    "Escopo": "Alcance",
    "Estes postos têm abastecimento no app, mas o concentrador não envia os dados da pista — por isso ficam fora do cálculo acima.": "Estas estaciones tienen carga de combustible en la aplicación, pero el concentrador no envía los datos de la playa — por eso quedan fuera del cálculo anterior.",
    "Estornado": "Revertido",
    "Evolução diária": "Evolución diaria",
    "Fator da Pontuação": "Factor de la Puntuación",
    "Fillin": "Fillin",
    "Fora": "Fuera",
    "Fora do PontuaX": "Fuera de PontuaX",
    "Fornecedor": "Proveedor",
    "Funcionários": "Empleados",
    "Gerando relatório com IA...": "Generando reporte con IA...",
    "Gestão Click": "Gestão Click",
    "Girou": "Giró",
    "Grupo de clientes": "Grupo de clientes",
    "ID Autorização": "ID Autorización",
    "ID Delivery": "ID de Entrega",
    "ID Posto": "ID Estación",
    "Inconsistências de Cobrança": "Inconsistencias de Cobro",
    "L |": "L |",
    "Lista Detalhada": "Lista Detallada",
    "Locais": "Lugares",
    "Local não identificado": "Lugar no identificado",
    "Loja": "Tienda",
    "Metas Atingidas": "Objetivos Alcanzados",
    "Modo TV (tela cheia)": "Modo TV (pantalla completa)",
    "Nenhum abastecimento em andamento": "Ninguna carga de combustible en curso",
    "Nenhuma diferença encontrada.": "No se encontraron diferencias.",
    "No PontuaX": "En PontuaX",
    "No app": "En la aplicación",
    "No app × Fora do app": "En la aplicación × Fuera de la aplicación",
    "Não Resolvidas": "No Resueltas",
    "Não encontrado": "No encontrado",
    "Não resgatado": "No canjeado",
    "Número da Sorte": "Número de la Suerte",
    "Ocorrências": "Ocurrencias",
    "Origem não identificada": "Origen no identificado",
    "Penetração do app por posto": "Penetración de la aplicación por estación",
    "Pergunte alguma coisa... Ex: 'Mostre os 10 clientes que mais abasteceram'": "Pregunte algo... Ej: 'Muestre los 10 clientes que más cargaron combustible'",
    "Pesquisar": "Buscar",
    "Ponto": "Punto",
    "Pontos Detalhados": "Puntos Detallados",
    "Pontos Distribuídos": "Puntos Distribuidos",
    "Pontos Distribuídos Por Usuário": "Puntos Distribuidos por Usuario",
    "Pontuação": "Puntuación",
    "Postos com horário errado": "Estaciones con horario incorrecto",
    "Preço": "Precio",
    "Preço Médio": "Precio Promedio",
    "Preço/Litro": "Precio/Litro",
    "Primeira regra do brinde (padrão)": "Primera regla del premio (predeterminada)",
    "Problema": "Problema",
    "Produto não identificado": "Producto no identificado",
    "Prêmio": "Premio",
    "Qtd (L)": "Cant. (L)",
    "Qtd:": "Cant.:",
    "Quadro": "Tablero",
    "Quantidade de desconto concedido": "Cantidad de descuento otorgado",
    "Rede de troca": "Red de canje",
    "Rede não identificada": "Red no identificada",
    "Regra - Combustível - Valor": "Regla - Combustible - Valor",
    "Regra do Clube de Vantagens": "Regla del Club de Beneficios",
    "Regras aplicadas:": "Reglas aplicadas:",
    "Relatório de Clientes sem Número da Sorte": "Reporte de Clientes sin Número de la Suerte",
    "Relatório de Pontos": "Reporte de Puntos",
    "Relatório de Pontuação Padrão": "Reporte de Puntuación Estándar",
    "Remover Pontos": "Quitar Puntos",
    "Reserva": "Reserva",
    "Reservado em": "Reservado en",
    "Reservado em (segundos)": "Reservado en (segundos)",
    "Resgatado": "Canjeado",
    "Resolvidas": "Resueltas",
    "Resultados:": "Resultados:",
    "Resumo Geral": "Resumen General",
    "Resumo por Quadro": "Resumen por Tablero",
    "Saldo": "Saldo",
    "Sem correspondência na pista:": "Sin correspondencia en la playa:",
    "Sem dados da pista no período": "Sin datos de la playa en el período",
    "Sem movimento diário no período.": "Sin movimiento diario en el período.",
    "Sem registro": "Sin registro",
    "Sorteio": "Sorteo",
    "Tag Cliente": "Tag Cliente",
    "Tag Frentista": "Tag Playero",
    "Tanque": "Tanque",
    "Tente reformular sua consulta": "Intente reformular su consulta",
    "Ticket médio": "Ticket promedio",
    "Tipo Combustível": "Tipo de Combustible",
    "Tipo de Transação": "Tipo de Transacción",
    "Tipos de Combustível": "Tipos de Combustible",
    "Totais por problema": "Totales por problema",
    "Total a Pagar": "Total a Pagar",
    "Total a Receber": "Total a Recibir",
    "Total abastecido": "Total cargado",
    "Total de Pontos": "Total de Puntos",
    "Total de Transações": "Total de Transacciones",
    "Total de clientes": "Total de clientes",
    "Total de visualizações": "Total de visualizaciones",
    "Total restante": "Total restante",
    "Transações": "Transacciones",
    "Unificado em": "Unificado en",
    "Unificação": "Unificación",
    "Usar data de troca": "Usar fecha de canje",
    "Use linguagem natural para solicitar relatórios. Ex: \"Mostre os 10 clientes que mais abasteceram\"": "Use lenguaje natural para solicitar reportes. Ej: \"Muestre los 10 clientes que más cargaron combustible\"",
    "Valor total dos abastecimentos": "Valor total de las cargas de combustible",
    "Vendas": "Ventas",
    "Vinculado": "Vinculado",
    "Volume total dos abastecimentos": "Volumen total de las cargas de combustible",
    "[Sem descrição]": "[Sin descripción]",
    "do valor no app": "del valor en la aplicación",
    "do volume no app": "del volumen en la aplicación",
    "lá e volte aqui para clicar em": "allá y vuelva aquí para hacer clic en",
    "no app": "en la aplicación",
    "registro(s)": "registro(s)",
    "status": "estado",
    "vencimento": "vencimiento",
    "| Real: R$": "| Real: R$",
    "Último abastecimento": "Última carga de combustible",
    "— esse(s) combustível(is) não existe(m) no sistema da bomba, então ficam fora da comparação acima.": "— ese(s) combustible(s) no existe(n) en el sistema del surtidor, por lo que quedan fuera de la comparación anterior.",
    "— o mês do nosso lado é reescrito a partir do ERP. Editar a competência só aqui não resolve: a próxima sincronização sobrescreve.": "— el mes de nuestro lado se reescribe a partir del ERP. Editar el mes de facturación solo aquí no resuelve: la próxima sincronización lo sobrescribe.",
};

export default catalogo;
